import { Component, OnInit } from '@angular/core';
import { interval } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { HeaderService } from '../../../../core/services/header.service';
import { ActionLogService } from '../../../../core/services/action-log.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-client-header-panel',
  templateUrl: './client-header-panel.component.html',
  styleUrls: ['./client-header-panel.component.scss']
})
export class ClientHeaderPanelComponent implements OnInit {

  newDate: Date = new Date();
  currentLoggedInUser = this.authenticationService.currentUserValue?.username;
  showNewsFlash: boolean = false;
  newsFlash: string[] = [];
  columnsLocalStorageNames: string[] = ['allNodeListColoumnsInfo', 'nodeListColoumnsInfo', 'userListColumnsInfo']
  isClientLogin = this.router.url.includes('desktopapp');
  constructor(
    private authenticationService: AuthenticationService,
    private headerService: HeaderService,
    private actionLogService: ActionLogService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    interval(1000).subscribe(() => {
     this.newDate = new Date();
    });
    this.getNewFlash();
  }

  logOut() {
    this.clearLocalStorage();
    this.headerService.toRedirectSessions = true;
    this.headerService.toRedirectDeployments = true;
    this.headerService.updateDeploymentList(null);
    this.actionLogService.addActionLog("SyncHPC", 'SignOut', this.currentLoggedInUser, this.currentLoggedInUser, 'User', 'Sign Out')
    this.authenticationService.logout(true, this.isClientLogin);
    //this.router.navigate(['Client/Login'], { queryParams: { user: this.loggedUserName } }).then(() => {window.location.reload()}) ;
  }
  clearLocalStorage() {
    this.columnsLocalStorageNames.forEach(el => localStorage.removeItem(el))
  }
  getNewFlash() {
    this.headerService.getNewFlash().subscribe({
      next: (data: any) => {
        if (data?.flashNews) {
          this.showNewsFlash = true;
          this.newsFlash = data?.flashNews?.split(',');
        }
        else {
          this.showNewsFlash = false;
        }
      },
      error: (err) => {
        this.showNewsFlash = false;
      }
    })
  }
}
